import GradeLessonPage from '../components/GradeLessonPage';
import { grade4Topics } from './data';

export default function Grade4Page() {
  return (
    <GradeLessonPage
      grade="4"
      gradeLabel="Grade 4"
      gradeColor="rose"
      topics={grade4Topics}
      prevGrade={{ label: 'Grade 3', path: '/grade/3' }}
      nextGrade={undefined}
    />
  );
}
